import cbcLogo from '../assets/logo/cbc-03.svg'
import { useAuth } from '../context/auth'

interface HeaderProps {
  onMenuOpen: () => void
}

export default function Header({ onMenuOpen }: Readonly<HeaderProps>) {
  const { user, logout } = useAuth()

  return (
    <header className="bg-gradient-to-r from-cbc-navy via-cbc-dark-blue to-cbc-dark-blue border-b border-cbc-medium-blue/15 sticky top-0 z-40 shadow-cbc-dark backdrop-blur-xl">
      <div className="flex items-center justify-between px-4 md:px-6 py-3">

        {/* Left: hamburger (mobile) + Branding */}
        <div className="flex items-center space-x-2 md:space-x-3">
          <button
            onClick={onMenuOpen}
            className="md:hidden p-2 -ml-1 rounded-md text-cbc-light-blue/80 hover:text-cbc-paper hover:bg-cbc-light-blue/10 transition-all duration-200"
            aria-label="Abrir menú de navegación"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
          <img
            src={cbcLogo}
            alt="Corporación de Bienes de Capital"
            className="h-7 md:h-8 w-auto brightness-0 invert opacity-90"
          />
          <div className="w-px h-7 bg-cbc-light-blue/20 hidden sm:block" />
          <span className="text-sm font-semibold text-cbc-light-blue tracking-wide hidden sm:block">
            Plataforma de Control de Gestión
          </span>
        </div>

        {/* User section */}
        <div className="flex items-center space-x-2 md:space-x-3">
          <div className="text-right hidden sm:block">
            <p className="text-sm font-semibold text-cbc-paper leading-tight">{user?.name}</p>
            <p className="text-xs text-cbc-medium-blue leading-tight">{user?.username}</p>
          </div>
          <div className="w-8 h-8 rounded-full bg-gradient-to-br from-cbc-primary to-cbc-medium-blue flex items-center justify-center text-white text-sm font-bold shadow-cbc flex-shrink-0">
            {user?.name?.charAt(0).toUpperCase()}
          </div>
          <div className="w-px h-7 bg-cbc-light-blue/20 hidden sm:block" />
          <button
            onClick={logout}
            className="flex items-center space-x-1.5 px-2.5 md:px-3 py-1.5 text-xs font-medium text-cbc-light-blue/80 hover:text-cbc-paper hover:bg-cbc-light-blue/10 rounded-md transition-all duration-200 border border-cbc-light-blue/15 hover:border-cbc-light-blue/35"
          >
            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
            <span className="hidden xs:inline sm:inline">Salir</span>
          </button>
        </div>

      </div>
    </header>
  )
}
